const BaseStationList = () => import('Views/baseStation/baseStation-list');
const BaseStationAddEdit = () => import('Views/baseStation/baseStation-addEdit');
const BaseStationDetail = () => import('Views/baseStation/baseStation-detail');
const BaseStationAlarm = () => import('Views/baseStation/baseStation-alarm');
const BaseStationBatchAlarm = () => import('Views/baseStation/baseStation-batch-alarm');
const BaseStationMaintenance = () => import('Views/baseStation/baseStation-maintenance');
const BaseStationParam = () => import('Views/baseStation/baseStation-param');

export default[
  { path: '/baseStation-list', component: BaseStationList },
  { path: '/baseStation-add', component: BaseStationAddEdit },
  { path: '/baseStation-edit/:id', component: BaseStationAddEdit },
  { path: '/baseStation-maintenance/:id', component: BaseStationMaintenance },
  { path: '/baseStation-detail/:id', component: BaseStationDetail },
  { path: '/baseStation-param', component: BaseStationParam },
  { path: '/baseStation-alarm/:id', component: BaseStationAlarm },
  { path: '/baseStation-batch-alarm', component: BaseStationBatchAlarm },
];



// WEBPACK FOOTER //
// ./src/router/baseStation.js